import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "extra-checkbox__message" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseCheckbox, {
      id: _ctx.extra.identifier,
      label: 'Add ' + _ctx.extra.description.toLowerCase(),
      disabled: _ctx.extra.disabled,
      modelValue: _ctx.inputValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
      class: "extra-checkbox",
      name: _ctx.extra.description
    }, null, 8, ["id", "label", "disabled", "modelValue", "name"]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.extra.notBookableMessage), 1)
  ], 64))
}